import React from 'react';
import { AuthHeader, AuthArtwork } from './AuthParts';

export default function StandardTemplate({ children }) {
    return <div className="auth-page auth-standard" data-auth-template="standard"><section className="auth-pane"><AuthHeader /><main className="auth-content">{children}</main><p className="auth-platform-note">Один аккаунт для всех наших сервисов</p></section><AuthArtwork /></div>;
}
